import { Grid, Space } from "../components/Layout";
import { Media, Title, Texts, Button } from "../components/Object";
import { Head, News, Banner, Contact } from "../components/Project";
import { HashLink } from "react-router-hash-link";

const Service = () => {
  return (
    <>
      <Head slug="page-partner"></Head>

      <div className="l-row">
        <div className="p-box__wrap--about">
          <Space size={["160px", "64px"]} />
          <Space size={["0px 0 64px", "0px 0 40px"]}>
            <Texts
              slug="about/title"
              addText="株式会社カナメカーゴでは、<br>現在パートナー会社様を<br>募集しております。"
            ></Texts>
          </Space>
          <Texts
            slug="about/body"
            addText="カナメカーゴは、ただモノを運ぶだけの運送会社ではありません。<br>
            お客様の多種多様なニーズに対応し、「<b class='c-text--main'>安全で正確な物流サービス</b>」を提供することで、人とモノをつなげる役割を担っています。<br>
            カナメカーゴは、お客様第一・迅速な対応をモットーにしており、お客様の信頼に応えるために社員一同努力をしてまいります。<br>
            <br>
            荷が薄い時に配車を調整したり、荷物の乗り合わせでコストをお互いに削減したりすることが多いかと思います。<br>
            効率的な業務を遂行できるように協力し合って、お仕事をしていきませんか？"
          ></Texts>
          <Space size={["160px", "80px"]} />
        </div>
      </div>
    
      
      <div className="p-box__wrap--white">
        <Space size={['120px', '80px']}></Space>
        <div className="l-row">
          <div className="c-grid--center">
            <Title slug="merit" enClass="c-text--center" type="en-single"></Title>
          </div>
        </div>
        <Space size={["80px 0 0", "80px 0 0"]}>
          <div className="l-row">
            <Media sp="sp" src="merit/main" alt="merit" class="p-img__merit"></Media>
          </div>
        </Space>
        <Space size={['120px', '80px']}></Space>
      </div>
    

      <Contact />

      <News />

      <Banner />
    </>
  );
};

export default Service;